import React from 'react';
import { ArrowUp, ArrowDown, Trash2, Youtube } from 'lucide-react';

const inputClass =
  'bg-zinc-950 border border-white/10 rounded-lg px-2.5 py-1.5 text-sm text-white focus:outline-none focus:border-neon-lime/60 transition-colors duration-200';

const IconBtn = ({ onClick, disabled, children, testId, label }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    className="p-1.5 rounded-lg text-zinc-500 hover:text-white hover:bg-white/5 disabled:opacity-30 disabled:hover:bg-transparent transition-colors duration-200"
    data-testid={testId}
  >
    {children}
  </button>
);

const ExerciseRow = ({ ex, index, total, onChange, onMove, onRemove, testPrefix }) => (
  <li className="flex flex-col sm:flex-row sm:items-center gap-2 py-3 border-b border-white/5 last:border-b-0" data-testid={`${testPrefix}-row`}>
    <div className="flex items-center gap-3 flex-1 min-w-0">
      <span className="w-6 text-xs font-bold text-neon-lime/70">{index + 1}</span>
      <div className="min-w-0">
        <p className="text-white text-sm font-medium truncate flex items-center gap-1.5" data-testid={`${testPrefix}-name`}>
          {ex.name}
          {ex.youtube_url && <Youtube className="w-3.5 h-3.5 text-red-500 flex-shrink-0" />}
        </p>
        {ex.category && <p className="text-[11px] text-zinc-500">{ex.category}</p>}
      </div>
    </div>
    <div className="flex items-center gap-2 pl-9 sm:pl-0">
      <input value={ex.execution_details} onChange={(e) => onChange({ execution_details: e.target.value })} placeholder="3 x 12 / 60 seg" className={`${inputClass} w-36`} data-testid={`${testPrefix}-details`} />
      <input value={ex.notes} onChange={(e) => onChange({ notes: e.target.value })} placeholder="Observação" className={`${inputClass} w-40 hidden md:block`} data-testid={`${testPrefix}-notes`} />
      <IconBtn onClick={() => onMove(-1)} disabled={index === 0} testId={`${testPrefix}-up`} label="Subir"><ArrowUp className="w-4 h-4" /></IconBtn>
      <IconBtn onClick={() => onMove(1)} disabled={index === total - 1} testId={`${testPrefix}-down`} label="Descer"><ArrowDown className="w-4 h-4" /></IconBtn>
      <IconBtn onClick={onRemove} disabled={total === 1} testId={`${testPrefix}-remove`} label="Remover"><Trash2 className="w-4 h-4" /></IconBtn>
    </div>
  </li>
);

export const AiDraftDay = ({ day, dayIndex, onUpdate }) => {
  const updateExercise = (i, patch) =>
    onUpdate({ exercises: day.exercises.map((ex, j) => (j === i ? { ...ex, ...patch } : ex)) });
  const moveExercise = (i, dir) => {
    const list = [...day.exercises];
    [list[i], list[i + dir]] = [list[i + dir], list[i]];
    onUpdate({ exercises: list });
  };
  const removeExercise = (i) => onUpdate({ exercises: day.exercises.filter((_, j) => j !== i) });

  return (
    <div className="bg-zinc-900/50 border border-white/5 rounded-2xl p-4 md:p-5" data-testid={`ai-day-${dayIndex}`}>
      <input
        value={day.name}
        onChange={(e) => onUpdate({ name: e.target.value })}
        className="w-full bg-transparent font-primary font-black text-lg text-white focus:outline-none border-b border-transparent focus:border-neon-lime/40 pb-1 transition-colors duration-200"
        data-testid={`ai-day-${dayIndex}-name`}
      />
      {day.focus && <p className="text-xs text-zinc-500 mt-1">{day.focus}</p>}
      <ul className="mt-2">
        {day.exercises.map((ex, i) => (
          <ExerciseRow
            key={`${ex.exercise_id}-${i}`}
            ex={ex}
            index={i}
            total={day.exercises.length}
            onChange={(patch) => updateExercise(i, patch)}
            onMove={(dir) => moveExercise(i, dir)}
            onRemove={() => removeExercise(i)}
            testPrefix={`ai-day-${dayIndex}-ex-${i}`}
          />
        ))}
      </ul>
    </div>
  );
};
